import { MatchType } from "../components/MatchHeaderDropdown";
import FontSize from "../config/FontSize";
import Stages from "../config/Stages";
import { UserPick } from "../services";

export type stageType = keyof typeof Stages;

export type fontWeightType =
  | "100"
  | "200"
  | "300"
  | "400"
  | "500"
  | "600"
  | "700"
  | "800"
  | "900";

export type fontSizeType = keyof typeof FontSize;
export interface IPLTeamLogos {
  [team: string]: { logo: string; name: string };
}
export interface TeamLogoWIthURI {
  logo: string;
  name: string;
}
export interface QuestionType {
  question_mid: number;
  match_mid: number;
  benchmark_value: number;
  question_type_name: QuestionTypeName;
}

export type QuestionTypeName = "WINNING_TEAM" | "BOUNDARIES" | "RUNS";

export type LiveScoreType = {
  numberOfPredictions?: string;
  predictedAnswer?: string;
  currentScore?: string;
  answered?: boolean;
  type?: QuestionTypeName;
  primaryLogo?: string;
  secondaryLogo?: string;
};

export type AnsweredType = {
  question_mid: string;
  match_mid: string;
  is_over: boolean | string;
  response_time_ms: string | number;
};

export const mapAbbrToLogo: IPLTeamLogos = {
  RR: {
    logo: "Logo/RR.png",
    name: "Rajasthan",
  },
  DC: {
    logo: "Logo/DC.png",
    name: "Delhi",
  },
  KKR: {
    logo: "Logo/KKR.png",
    name: "Kolkata",
  },
  RCB: {
    logo: "Logo/RCB.png",
    name: "Bangalore",
  },
  SRH: {
    logo: "Logo/SRH.png",
    name: "Hyderabad ",
  },
  LSG: {
    logo: "Logo/LSG.png",
    name: "Lucknow",
  },
  PBKS: {
    logo: "Logo/PBKS.png",
    name: "Punjab",
  },
  MI: {
    logo: "Logo/MI.png",
    name: "Mumbai",
  },
  CSK: {
    logo: "Logo/CSK.png",
    name: "Chennai",
  },
  GT: {
    logo: "Logo/GT.png",
    name: "Gujarat",
  },
  NEW: {
    logo: "Logo/GT.png",
    name: "NEW",
  },
  WAS: {
    logo: "Logo/GT.png",
    name: "WAS",
  },
  TEX: {
    logo: "Logo/GT.png",
    name: "TEX",
  },
  SEA: {
    logo: "Logo/GT.png",
    name: "SEA",
  },
};

export const mapAbbrToLogoWithURL = (
  choice: MatchType,
  away: boolean
): TeamLogoWIthURI => {
  return {
    logo: away
      ? choice.away_team_logo_url
        ? choice.away_team_logo_url
        : "logo.png"
      : choice.home_team_logo_url
      ? choice.home_team_logo_url
      : "logo.png",
    name: away ? choice.away_team_abbreviation : choice.home_team_abbreviation,
  };
};

export type GroupedUserPicks = {
  [key: number]: UserPick[];
};
export function groupUserPicks(userPicksList: UserPick[]): GroupedUserPicks {
  const groupedPicks: GroupedUserPicks = {};
  userPicksList.sort((a: UserPick, b: UserPick) => {
    return a.question_mid - b.question_mid;
  });

  userPicksList.forEach((pick) => {
    if (!groupedPicks[pick.match_mid]) {
      groupedPicks[pick.match_mid] = [pick];
    } else {
      groupedPicks[pick.match_mid].push(pick);
    }
  });

  return groupedPicks;
}

export const calculateMultiplier = (x: number) => {
  if (x === 1) return 10;
  if (x === 2) return 25;
  if (x === 3) return 50;
};

export const isMobile = window.innerWidth < 768;
